import { createTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import React from "react";
import { Provider } from "react-redux";
import { Route, Router, Switch, useLocation } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import "./App.scss";
import "./Auth.scss";
import "./dashboard.scss";
import ForgotPassword from "./components/auth/forgotPassword";
import ForgotUserId from "./components/auth/forgotUserId";
import LoginLayout from "./components/auth/layout";
import Login from "./components/auth/login";
import OTP from "./components/auth/otp";
import Register from "./components/auth/register";
import ResetPassword from "./components/auth/resetPassword";
import Home from "./components/home/home";
import ProtectedRoute from "./protectedRoute";
import store, { history, persistor } from "./store";
import ScrollToTop from "./components/common/scroll-to-top";
import RefreshToken from "./components/common/refresh";
import CustomLoader from "./components/forms/Loader";
import { Popup } from "./components/home/customModal";

const PUBLIC_URL = process.env.PUBLIC_URL || "/";

const loginRoutes = {
  "/login": Login,
  "/otp": OTP,
  "/forgot-userid": ForgotUserId,
  "/forgot-password": ForgotPassword,
  "/reset-password": ResetPassword,
  "/register": Register,
};

const Routes = () => {
  return (
    <Router history={history} basename={PUBLIC_URL}>
      <ScrollToTop />
      <RefreshToken />
      <CustomLoader />
      <Switch>
        {Object.keys(loginRoutes).map((route) => (
          <Route path={route} component={LoginWrapper} key={route} />
        ))}

        <ProtectedRoute path={`/`} component={Home} />
      </Switch>
    </Router>
  );
};

function LoginWrapper(props) {
  const location = useLocation();
  const path = location && location.pathname;
  const Component = loginRoutes[path] || Login;

  return (
    <LoginLayout>
      <Component {...props} />
    </LoginLayout>
  );
}

const theme = createTheme({
  overrides: {
    MuiMenuItem: {
      root: {
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
      },
    },
    MuiSelect: {
      selectMenu: {
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
      },
    },
  },
});

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <PersistGate persistor={persistor}>
          <Popup />
          <Routes />
        </PersistGate>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
